// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.mytextarea[data-v-f933a1f2] {\n    scrollbar-width: none; /*Firefox対応のスクロールバー非表示コード*/  \n    -ms-overflow-style: none;/*Internet Explore対応のスクロールバー非表示コード*/\n}\n.mytextarea[data-v-f933a1f2]::-webkit-scrollbar {  \n  display: none; /*Google Chrome、Safari、Microsoft Edge対応のスクロールバー非表示コード*/\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
